<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <template v-if="!item.hidden && item.children">
        <router-link
          v-if="item.children.length === 1  && (!item.meta || (item.meta && !item.meta.showAlways)) && !item.children[0].children"
          :to="item.path + '/' + item.children[0].path"
          :key="item.children[0].name"
        >
          <el-menu-item :index="item.path + '/' + item.children[0].path">
            <icon
              v-if="item.children[0].meta && item.children[0].meta.icon"
              :name="item.children[0].meta.icon"
            ></icon>
            <template slot="title">
              <span
                v-if="item.children[0].meta && item.children[0].meta.title"
                >{{ $t(item.children[0].meta.title) }}</span
              >
            </template>
          </el-menu-item>
        </router-link>

        <el-submenu
          popper-class="sidebar-submenu"
          v-else
          :index="item.name || item.path"
          :key="item.name"
        >
          <template slot="title">
            <icon
              v-if="item.meta && item.meta.icon"
              :name="item.meta.icon"
            ></icon>
            <span v-if="item.meta && item.meta.title">{{
              $t(item.meta.title)
            }}</span>
          </template>

          <template v-for="child in item.children">
            <template v-if="!child.hidden">
              <sidebar-item
                class="nest-menu"
                v-if="child.children && child.children.length > 0"
                :routes="[child]"
                :key="child.path"
              ></sidebar-item>

              <router-link
                v-else
                :to="item.path + '/' + child.path"
                :key="child.name"
              >
                <el-menu-item :index="item.path + '/' + child.path">
                  <icon
                    v-if="child.meta && child.meta.icon"
                    :name="child.meta.icon"
                  ></icon>
                  <span v-if="child.meta && child.meta.title">{{
                    $t(child.meta.title)
                  }}</span>
                </el-menu-item>
              </router-link>
            </template>
          </template>
        </el-submenu>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    }
  }
}
</script>
<style lang="scss">
.sidebar-submenu {
  background-color: #373d41;
}
</style>
